var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('h1',[_vm._v("Forbidden")]),_c('p',[_vm._v("You do not have sufficient permissions to view the requested page.")])])}
var staticRenderFns = []

export { render, staticRenderFns }